export default __webpack_public_path__ + "static/media/element_74.0beba189.jpg";